(function() {
  var Controller,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.ApiDataForwardingController = (function(superClass) {
    extend(ApiDataForwardingController, superClass);

    function ApiDataForwardingController(scope, location, stateParams, http, Session) {
      var id;
      this.scope = scope;
      this.location = location;
      this.stateParams = stateParams;
      this.http = http;
      id = this.stateParams.token;
      this.http.get((Config.get('api_url')) + "/transfer-data/" + id).then((function(_this) {
        return function(response) {
          var transferData;
          transferData = response.data.data;
          return _this.http.get((Config.get('api_url')) + "/transfer-data-token/" + id).then(function(response) {
            var token;
            token = response.data.token;
            Session.set('Authorization', "Bearer " + token);
            Session.set('SafeLink', "Bearer " + token);
            Session.set('OriginalUser', "Bearer " + token);
            Session.set('AuthTime', new Date().getTime());
            _this.http.get((Config.get('api_url')) + "/me").then(function(response) {
              Socket.whenopen(function() {
                return Socket.socket.send(response.data.id);
              });
              return typeof Raven !== "undefined" && Raven !== null ? Raven.setUserContext(response.data) : void 0;
            });
            return _this.location.url(transferData.url);
          });
        };
      })(this));
    }

    return ApiDataForwardingController;

  })(Controller);

}).call(this);
